import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../../services/firebase/config';
import { toast } from 'react-toastify';
import { 
  FiHome, 
  FiFolder, 
  FiFileText, 
  FiUser, 
  FiImage, 
  FiSettings,
  FiMail,
  FiLogOut,
  FiMenu,
  FiX,
  FiExternalLink,
  FiGrid
} from 'react-icons/fi';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { path: '/admin', icon: FiGrid, label: 'Dashboard', exact: true },
    { path: '/admin/accueil', icon: FiHome, label: 'Accueil' },
    { path: '/admin/projets', icon: FiFolder, label: 'Projets' },
    { path: '/admin/blog', icon: FiFileText, label: 'Blog' },
    { path: '/admin/a-propos', icon: FiUser, label: 'À Propos' },
    { path: '/admin/medias', icon: FiImage, label: 'Médias' },
    { path: '/admin/messages', icon: FiMail, label: 'Messages' },
    { path: '/admin/parametres', icon: FiSettings, label: 'Paramètres' },
  ];

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success('Déconnexion réussie');
      navigate('/');
    } catch (error) {
      toast.error('Erreur lors de la déconnexion');
    }
  };

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      {/* Overlay pour mobile */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <h2>GK Admin</h2>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link to="/" className="sidebar-nav-item" target="_blank">
            <FiExternalLink />
            <span>Voir le site</span>
          </Link>
          <button onClick={handleLogout} className="sidebar-nav-item logout-btn">
            <FiLogOut />
            <span>Déconnexion</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <header className="admin-header">
          <button 
            className="menu-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
          
          <div className="header-title">
            {menuItems.find(item => isActive(item.path, item.exact))?.label || 'Admin'}
          </div>

          <div className="header-user">
            <span>{auth.currentUser?.email}</span>
          </div>
        </header>

        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;